export default __webpack_public_path__ + "static/media/NW0200.34I-38126_-22439_0.616cd016.jpg";